import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { putError } from '@/store/error.store';
import momentLocalizer from 'react-widgets-moment';
import { dateTimePickerFormat } from '@/util/util';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

const updateField = (state, dealId, productId, updateFunc) =>
  state.set('data', state.get('data')
    .map(dataList => dataList.map((d) => {
      if (d.get('dealId') === dealId &&
       (productId === undefined || d.getIn(['compositeProduct', 'id']) === productId)) {
        return updateFunc(d);
      }
      return d;
    })));

const updateFieldByIdx = (state, idx, updateFunc) =>
  state.set('data', state.get('data')
    .map(dataList => dataList.map((d) => {
      if (d.get('idx') === idx) {
        return updateFunc(d);
      }
      return d;
    })));

const updateAllFields = (state, updateFunc) =>
  state.set('data', state.get('data')
    .map(dataList => dataList.map((d) => updateFunc(d))));


const updateMarketPriceStore = (state, dealId, productId, marketPrice) =>
  updateField(state, dealId, productId,
    d => d.set('compositeProduct', d.get('compositeProduct')
      .set('marketPrice', marketPrice).set('marketPriceDate',
        moment(new Date()).format(dateTimePickerFormat))));


const updateExternalPrice = (state, dealId, externalPrice, portId) =>
  updateField(state, dealId, undefined,
    d => d.set('externalM2M', externalPrice).setIn(['compositeProduct', 'fobPort'], portId));

const updateCheckState = (state, idx, checkState) =>
  updateFieldByIdx(state, idx, d => d.set('checkState', checkState));

const updateAllCheckState = (state, checkState) =>
  updateAllFields(state, d => d.set('checkState', checkState));

const dataLoaded = (state, data) => {
  const result = {};
  let idx = 0;
  Object.keys(data).forEach(key => {
    result[key] = data[key].map(item => ({
      ...item,
      idx: idx++,
    }));
  });
  return fromJS(result);
};

export const positionBookReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'DATE_REPORT_LOADED':
      return state.set('data', dataLoaded(state, action.data))
        .set('done', true).set('loading', false);
    case 'UPDATE_PRODUCT_TYPES':
      return state.set('productTypes', fromJS(action.productTypes));
    case 'LOADING_DATE_REPORT':
      return state.set('loading', true).set('done', false).set('data', new Map());
    case 'DATE_REPORT_CLEAR':
      return state.clear();
    case 'SELECT_PRODUCT':
      return state.set('dealType', action.dealType).set('productId', action.productId);
    case 'UPDATE_DEAL_MARKET_PRICE_COMPLETED':
      return updateMarketPriceStore(state, action.dealId, action.productId, action.marketPrice);
    case 'FOB_PORT_UPDATED':
      return updateExternalPrice(state, action.dealId, action.externalPrice, action.portId);
    case 'POSITION_BOOK_UPDATE_CHECK_STATE':
      return updateCheckState(state, action.idx, action.checkState);
    case 'POSITION_BOOK_UPDATE_ALL_CHECK_STATE':
      return updateAllCheckState(state, action.checkState);
    default:
      return state;
  }
};

export const updateProductTypes = (dispatch, productTypes) =>
  dispatch({ type: 'UPDATE_PRODUCT_TYPES', productTypes });

export const updateCheckStateDispatch = (dispatch, idx, checkState) =>
  dispatch({ type: 'POSITION_BOOK_UPDATE_CHECK_STATE', idx, checkState });

export const allCheckStateDispatch = (dispatch, checkState) =>
  dispatch({ type: 'POSITION_BOOK_UPDATE_ALL_CHECK_STATE', checkState });

export const selectProduct = (dispatch, dealType, productId) =>
  dispatch({ type: 'SELECT_PRODUCT', dealType, productId });

export const clearPositionBookReport = dispatch => dispatch({ type: 'DATE_REPORT_CLEAR' });

export const generateReport = (dispatch, productGroups) => {
  selectProduct(dispatch, null, null);
  dispatch({ type: 'LOADING_DATE_REPORT' });
  markStoreLoading(dispatch);
  return RestAPI.get(`/api/report/positionbook?productGroups=${productGroups}`)
    .then(
      (data) => {
        dispatch({ type: 'DATE_REPORT_LOADED', data });
        markStoreLoaded(dispatch);
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'DATE_REPORT_LOADING_FAILED' });
        markStoreLoaded(dispatch);
        return true;
      },
    );
};

export const updateFobPort = (dispatch, productId, dealId, portId) => {
  dispatch({ type: 'FOB_PORT_UPDATING' });
  return RestAPI.patch(`/api/report/updateFobPort/${productId}?portId=${portId}&deliveryTerm=FOB`)
    .then(
      (data) => {
        dispatch({ type: 'FOB_PORT_UPDATED', dealId, externalPrice: data, portId });
        return true;
      },
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'FOB_PORT_UPDATE_FAILED' });
        return true;
      },
    );
};
